import axios from 'axios';

import routes from 'app/routes';

function prepareFormData(values) {
  const formData = new FormData();
  formData.append('name', values.name);
  formData.append('greeting', values.greeting);
  formData.append('description', values.description);
  formData.append('is_public', values.is_public);
  formData.append('is_inline', values.is_inline);
  formData.append('heygen', values.heygen);
  formData.append('bedrock_agent', values.bedrock_agent);
  formData.append('bedrock_alias', values.bedrock_alias);
  values.prompt_ids.forEach((id) => {
    formData.append('prompt_ids[]', id);
  });
  if (values.preview_image) {
    formData.append('preview_image', values.preview_image);
  }

  return formData;
}

export default {
  create: (values, onSuccess, onError) => {
    axios
      .post(
        routes.api.super_admins.avatars.create,
        prepareFormData(values),
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((_resp) => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  update: (avatarId, values, onSuccess, onError) => {
    axios
      .patch(
        routes.api.super_admins.avatars.update(avatarId),
        prepareFormData(values),
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((_resp) => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  destroy: (avatarId, onSuccess) => {
    axios
      .delete(routes.api.super_admins.avatars.destroy(avatarId))
      .then((_resp) => {
        onSuccess();
      });
  },
};
